/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ProjectsControllerFindAllQueryResponse, ProjectsControllerFindAllQueryParams, ProjectsControllerFindAll401, ProjectsControllerFindAll403 } from "../../models/projectsController/ProjectsControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { projectsControllerFindAll } from "../../clients/projectsService/projectsControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const projectsControllerFindAllQueryKey = (params: ProjectsControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/projects'
}, ...(params ? [params] : [])] as const;
export type ProjectsControllerFindAllQueryKey = ReturnType<typeof projectsControllerFindAllQueryKey>;
export function projectsControllerFindAllQueryOptions(params?: ProjectsControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = projectsControllerFindAllQueryKey(params);
  return queryOptions<ProjectsControllerFindAllQueryResponse, ResponseErrorConfig<ProjectsControllerFindAll401 | ProjectsControllerFindAll403>, ProjectsControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return projectsControllerFindAll(params, config);
    }
  });
}

/**
 * @summary Get all projects for the current user
 * {@link /api/v1/projects}
 */
export function useProjectsControllerFindAll<TData = ProjectsControllerFindAllQueryResponse, TQueryData = ProjectsControllerFindAllQueryResponse, TQueryKey extends QueryKey = ProjectsControllerFindAllQueryKey>(params?: ProjectsControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<ProjectsControllerFindAllQueryResponse, ResponseErrorConfig<ProjectsControllerFindAll401 | ProjectsControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? projectsControllerFindAllQueryKey(params);
  const query = useQuery({
    ...projectsControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ProjectsControllerFindAll401 | ProjectsControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}